import script from "./realtime-risk-terminal-ranking.vue?vue&type=script&lang=ts&setup=true"
export * from "./realtime-risk-terminal-ranking.vue?vue&type=script&lang=ts&setup=true"

import "./realtime-risk-terminal-ranking.vue?vue&type=style&index=0&id=3166504c&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3166504c"]])

export default __exports__